import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import App from './App';

// scripts/prerender.js bakes fully-rendered HTML into each page so crawlers and
// the AdSense reviewer see real content in the initial response. We deliberately
// do NOT hydrate: the app is highly dynamic (random puzzles, timers, live API
// data), so hydration mismatches every load and React falls back to a full
// client render anyway (React #423). Client-rendering directly gives the exact
// same result without the failed-hydration overhead or console errors. React
// clears the prerendered #root markup and renders fresh on top of it.
const rootElement = document.getElementById('root');
createRoot(rootElement).render(<React.StrictMode><App /></React.StrictMode>);
